import { postReport } from '../../../../services/api.js';
import { reportFilterFields } from '../../../../utils/reportRequestBody.js';

/**
 * ehrTasksReportApi.js — the EHR Tasks report's one call.
 *
 * mysql_report.py `ehrTasksReport` → getEhrTasksReportData: every pending EHR task for the
 * campus, bucketed like the EHR Tasks page (docs/EHR_TASKS_REPORT_PLAN.md section 5.1). The
 * Lambda reads the integration flags itself, so the browser never decides which sections
 * exist.
 *
 * @param {object} opts
 * @param {number} opts.campusId
 * @param {string[]} [opts.taskTypes] — bucket keys (utils/ehrTaskTypes.js); empty = every type
 * @returns {Promise<object>} — { asOfUtc, inactive, buckets, counts, records, flags } or { ErrorCode }
 */
export async function fetchEhrTasksReport({ campusId, taskTypes = [] }) {
    const body = {
        rep_type: 'ehrTasksReport',
        campus_id: campusId,
        /* The standard filter keys go out empty, as on every report; the Lambda reads only
           ehr_task_filter. */
        ...reportFilterFields({ taskTypes: (taskTypes || []).join(',') }),
    };

    const res = await postReport(body, '[ehrTasksReportApi] fetchEhrTasksReport error');
    if (res.ErrorCode) return { ErrorCode: res.ErrorCode };
    const data = res.data || {};

    return {
        asOfUtc: data.as_of_utc || '',
        inactive: Boolean(data.inactive),
        buckets: Array.isArray(data.buckets) ? data.buckets : [],
        counts: data.counts || {},
        records: Array.isArray(data.records) ? data.records : [],
        flags: data.flags || {},
    };
}
